import { render, staticRenderFns } from "./ClientAnswerForSc.component.vue?vue&type=template&id=3f5efabc&scoped=true&"
import script from "./ClientAnswerForSc.component.vue?vue&type=script&lang=js&"
export * from "./ClientAnswerForSc.component.vue?vue&type=script&lang=js&"
import style0 from "./ClientAnswerForSc.component.vue?vue&type=style&index=0&id=3f5efabc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5efabc",
  null
  
)

export default component.exports